var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.cmsHtml)?_c('div',{staticClass:"cms-content",domProps:{"innerHTML":_vm._s(_vm.cmsHtml)}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }